/* eslint-disable import/no-cycle */
import {
  getInvoiceByRequestId,
  postRequestInvoice,
  requestPay,
  getShoppingCartByUserId,
  getShoppingCartPaymentMethods,
  removeInvoiceFromShoppingCart,
  postInvoiceToShoppingCartById,
  postShoppingCart,
  getInvoicePaymentMethods,
} from './services/financial-api';
import { getOrderById, getOrders } from './services/payment-api';

export const SET_INVOICE_BY_REQUEST_ID = 'financials/SET_INVOICE_BY_REQUEST_ID';
export const FETCH_INVOICE_BY_REQUEST_ID = 'financials/FETCH_INVOICE_BY_REQUEST_ID';
export const POST_REQUEST_INVOICE = 'financials/POST_REQUEST_INVOICE';
export const REQUEST_PAY = 'financials/REQUEST_PAY';
export const FETCH_ORDER_BY_ID = 'financials/SET_SEARCH_REQUEST';
export const FETCH_ORDERS = 'financials/FETCH_ORDERS';
export const FETCH_SHOPPING_CART_BY_USER_ID = 'financials/FETCH_SHOPPING_CART_BY_USER_ID';
export const SET_SHOPPING_CART_BY_USER_ID = 'financials/SET_SHOPPING_CART_BY_USER_ID';
export const FETCH_SHOPPING_CART_PAYMENT_METHODS = 'financials/FETCH_SHOPPING_CART_PAYMENT_METHODS';
export const SET_SHOPPING_CART_PAYMENT_METHODS = 'financials/SET_SHOPPING_CART_PAYMENT_METHODS';
export const REMOVE_INVOICE_FROM_SHOPPING_CART = 'financials/REMOVE_INVOICE_FROM_SHOPPING_CART';
export const POST_INVOICE_TO_SHOPPING_CART = 'financials/POST_INVOICE_TO_SHOPPING_CART';
export const POST_SHOPPING_CART = 'financials/POST_SHOPPING_CART';
export const FETCH_INVOICE_PAYMENT_METHODS = 'financials/FETCH_INVOICE_PAYMENT_METHODS';
export const SET_INVOICE_PAYMENT_METHODS = 'financials/SET_INVOICE_PAYMENT_METHODS';

export const financialStore = {
  state: {
    invoice: null,
    shoppingCart: null,
    shoppingCartPaymentMethods: null,
    invoicePaymentMethods: null,
  },
  mutations: {
    [SET_INVOICE_BY_REQUEST_ID](state, { payload }) {
      state.invoice = payload;
    },
    [SET_SHOPPING_CART_BY_USER_ID](state, { payload }) {
      state.shoppingCart = payload;
    },
    [SET_SHOPPING_CART_PAYMENT_METHODS](state, { payload }) {
      state.shoppingCartPaymentMethods = payload;
    },
    [SET_INVOICE_PAYMENT_METHODS](state, { payload }) {
      state.invoicePaymentMethods = payload;
    },
  },
  getters: {
    getInvoiceByRequestId: (state) => state.invoice,
    getShoppingCartByUserId: (state) => state.shoppingCart,
    getShoppingCartPaymentMethods: (state) => state.shoppingCartPaymentMethods,
    getInvoicePaymentMethods: (state) => state.invoicePaymentMethods,
  },
  actions: {
    [POST_REQUEST_INVOICE]: async (_, payload) => {
      try {
        const data = payload;
        const resp = await postRequestInvoice(data);
        // commit(SET_SEARCH_REQUEST, { payload: null});
        return resp.data;
      } catch (error) {
        console.error('update request_err: ', error);
        throw error;
      }
    },
    [REQUEST_PAY]: async (_, payload) => {
      try {
        const order = payload;
        const resp = await requestPay(order);
        return resp.data;
      } catch (error) {
        console.error('search request_pay err: ', error);
        throw error;
      }
    },
    [FETCH_INVOICE_BY_REQUEST_ID]: async ({ commit }, payload) => {
      try {
        const requestId = payload;
        const resp = await getInvoiceByRequestId(requestId);
        const { data } = resp;
        commit(SET_INVOICE_BY_REQUEST_ID, { payload: data });
      } catch (error) {
        commit(SET_INVOICE_BY_REQUEST_ID, { payload: null });
        console.error('get-invoice-by-id_err: ', error);
        throw error;
      }
    },
    [FETCH_ORDER_BY_ID]: async (_, payload) => {
      try {
        const orderId = payload;
        const resp = await getOrderById(orderId);
        return resp.data[0];
      } catch (error) {
        console.error('get-order-by-id_err: ', error);
        throw error;
      }
    },
    [FETCH_ORDERS]: async (_, payload) => {
      try {
        const orderId = payload;
        const resp = await getOrders(orderId);
        return resp.data;
      } catch (error) {
        console.error('get-orders_err: ', error);
        throw error;
      }
    },
    [FETCH_SHOPPING_CART_BY_USER_ID]: async ({ commit }, payload) => {
      try {
        const userId = payload;
        const resp = await getShoppingCartByUserId(userId);
        const data = resp.data[0];
        commit(SET_SHOPPING_CART_BY_USER_ID, { payload: data });
      } catch (error) {
        commit(SET_SHOPPING_CART_BY_USER_ID, { payload: null });
        console.error('get-shopping-cart-by-id_err: ', error);
        throw error;
      }
    },
    [FETCH_SHOPPING_CART_PAYMENT_METHODS]: async ({ commit }) => {
      try {
        const resp = await getShoppingCartPaymentMethods();
        const { data } = resp;
        commit(SET_SHOPPING_CART_PAYMENT_METHODS, { payload: data });
      } catch (error) {
        commit(SET_SHOPPING_CART_PAYMENT_METHODS, { payload: null });
        console.error('get-pamyment-method_err: ', error);
        throw error;
      }
    },
    [REMOVE_INVOICE_FROM_SHOPPING_CART]: async (_, payload) => {
      try {
        const invoiceId = payload;
        const resp = await removeInvoiceFromShoppingCart(invoiceId);
        return resp.data;
      } catch (error) {
        console.error('remove-invoice-from-shopping-cart_err: ', error);
        throw error;
      }
    },
    [POST_INVOICE_TO_SHOPPING_CART]: async (_, payload) => {
      try {
        const invoiceId = payload;
        const resp = await postInvoiceToShoppingCartById(invoiceId);
        return resp;
      } catch (error) {
        console.error('search request_pay err: ', error);
        throw error;
      }
    },
    [POST_SHOPPING_CART]: async (_, payload) => {
      try {
        const data = payload;
        const resp = await postShoppingCart(data);
        return resp;
      } catch (error) {
        console.error('search request_pay err: ', error);
        throw error;
      }
    },
    [FETCH_INVOICE_PAYMENT_METHODS]: async ({ commit }, payload) => {
      try {
        const invoiceId = payload;
        const resp = await getInvoicePaymentMethods(invoiceId);
        const { data } = resp;
        commit(SET_INVOICE_PAYMENT_METHODS, { payload: data });
      } catch (error) {
        commit(SET_INVOICE_PAYMENT_METHODS, { payload: null });
        console.error('get-invoice-pamyment-method_err: ', error);
        throw error;
      }
    },
  },
};
